import {Offer} from './domain/types';

export const extractClinicLocationToDisplay = (offer: Partial<Offer> | null): { id: string | null, name: string | null } => {
    if (offer?.clinic?.guid) {
        return {
            id: offer.clinic?.guid,
            name: `${offer.clinic?.city} - ${offer.clinic?.street}`,
        };
    }

    // Remove due to BHPNPP-2515
    // if (offer?.otherClinicLocation) {
    //     return {
    //         id: "__OTHER__",
    //         name: "Other",
    //     };
    // }
    return {
        id: null,
        name: null,
    };
}

export * from './component/NewOfferForm';
export * from './component/EditOfferForm';
export * from './component/OfferView';

export * from './domain/types';

export * from './hook/useOfferByGuid';
export * from './hook/useCancelOffer$';
